import { hbs } from 'ember-cli-htmlbars';
export default hbs("<Ui::LineChart\n  @id={{@id}}\n  @data={{this.data}}\n  @options={{this.options}}\n  @toggledDatasetIndex={{@toggledDatasetIndex}}\n/>")